/** Menu + tile permission helpers. */

import tenantStorage from './tenantStorage';

function readJson(key, fallback) {
  try {
    const raw = tenantStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
    return parsed && typeof parsed === 'object' ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function getMenuAccess() {
  return readJson('menuAccess', {});
}

export function getPermissions() {
  return readJson('permissions', {});
}

/** Store login/session access maps. */
export function setAccessMaps({ menuAccess, permissions } = {}) {
  tenantStorage.setItem('menuAccess', JSON.stringify(menuAccess || {}));
  tenantStorage.setItem('permissions', JSON.stringify(permissions || {}));
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('renttick-auth-updated'));
  }
}

/** @deprecated use setAccessMaps */
export function setPermissions(permissions) {
  // Legacy callers may still pass a flat map; treat as tile permissions only.
  setAccessMaps({ menuAccess: getMenuAccess(), permissions });
  if (permissions && typeof permissions === 'object') {
    tenantStorage.setItem('permissions', JSON.stringify(permissions));
  }
}

export function canAccessMenu(menuKey) {
  if (!menuKey) return false;
  const access = getMenuAccess();
  return Boolean(access[menuKey]);
}

export function hasPermission(permissionKey) {
  if (!permissionKey) return false;
  const perms = getPermissions();
  return Boolean(perms[permissionKey]);
}

/** @deprecated — prefer canAccessMenu / hasPermission */
export function canRead(menuKey) {
  return canAccessMenu(menuKey);
}

/** @deprecated */
export function canWrite(menuKey) {
  return canAccessMenu(menuKey);
}

export function hasAtLeast(menuKey, _minLevel) {
  return canAccessMenu(menuKey);
}
